export default __webpack_public_path__ + "static/media/confirmation.7d0e83ec.png";